/**
 * Generate a full barcode from a payload provided as argument.
 */
export function generateCode128B(barcodeData: string): string {
  const charsetB =
    ' !"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÃÄÅÆÇÈÉÊ';
  const startBValue = 104;

  let sum = startBValue;
  for (let i = 0; i < barcodeData.length; i++) {
    const charValue = charsetB.indexOf(barcodeData[i]);
    if (charValue === -1) {
      throw new Error(`Invalid character in barcode data: ${barcodeData[i]}`);
    }
    sum += (i + 1) * charValue;
  }

  const checkValue = sum % 103;
  const checkCharacter = charsetB[checkValue] || '';
  return `Ì${barcodeData}${checkCharacter}Î`;
}
